{
  "bodyHelp": "Markdown wird unterstützt. Ihr Benutzername wird automatisch ergänzt.",
  "bodyLabel": "Beschreibung",
  "bodyPlaceholder": "Was haben Sie getan, was ist passiert und was hatten Sie erwartet?",
  "bodyWithReference": "Referenz: {{reference}}\n\n",
  "hint": "Melden Sie dem DMW-Team einen Fehler oder etwas, das schwer zu bedienen ist.",
  "menuItem": "Problem melden…",
  "sending": "Wird gesendet …",
  "sent": "Danke. Ihre Meldung wurde gesendet.",
  "submit": "Meldung senden",
  "title": "Problem melden",
  "titleLabel": "Titel",
  "titlePlaceholder": "Kurze Zusammenfassung des Problems"
}
